const inputs = {
  firestorePath: 'inputs',
  firestoreRefType: 'collection',
  moduleName: 'inputs',
  statePropName: 'data',
  namespaced: true,
  state: {},
  getters: {
    array: (state) => {
      const arr = Object.values(state.data);
      return arr.sort((a, b) => {
        const an = (a.name || '').toLowerCase();
        const bn = (b.name || '').toLowerCase();
        if (an < bn) return -1;
        if (an > bn) return 1;
        return 0;
      });
    },
    enabled: (state) => Object.values(state.data).filter((i) => i && i.enabled !== false),
    byId: (state) => (id) => state.data[id],
  },
  mutations: {},
  actions: {},
};

export default inputs;
